import { useDeferredValue } from 'react';
import { KebabSVG } from '@sbercloud/uikit-product-icons';
import { AdaptiveDroplist } from '@sbercloud/uikit-product-mobile-dropdown';
import { ButtonFunction } from '@snack-uikit/button';
import { Card } from '@snack-uikit/card';
import { useCalculatorContext } from '../../../../contexts';
import { formatNumber, getPrice, getValue, parseKeyToDataTest } from '../../../../utils';
import { PRICE_NAME } from '../PricePeriodSelect';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function ProductCard(_ref) {
  var id = _ref.id,
    idx = _ref.idx,
    label = _ref.label,
    selectedProduct = _ref.selectedProduct,
    onProductClick = _ref.onProductClick,
    onProductDelete = _ref.onProductDelete;
  var _useCalculatorContext = useCalculatorContext(),
    layoutType = _useCalculatorContext.layoutType,
    pricePeriod = _useCalculatorContext.pricePeriod,
    calculatorType = _useCalculatorContext.calculatorType,
    products = _useCalculatorContext.products;
  var isPartners = calculatorType === 'partners';
  var isChecked = (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id) === id && (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.idx) === idx;
  var dataTestAttribute = parseKeyToDataTest('price', 'summary-product-card');
  var price = useDeferredValue(getValue(products, "[".concat(id, "][").concat(idx, "].price")));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Card, {
      size: "s",
      onClick: function onClick() {
        onProductClick(id, idx);
      },
      checked: isChecked,
      outline: true,
      "data-test-id": dataTestAttribute,
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.wrapper,
          children: [/*#__PURE__*/_jsx(Card.Header, {
            truncate: {
              title: 10,
              description: 20
            },
            title: label,
            description: "".concat(formatNumber(getPrice({
              price: price,
              pricePeriod: pricePeriod,
              partners: isPartners
            })), " \u20BD ").concat(PRICE_NAME[pricePeriod])
          }), /*#__PURE__*/_jsx(AdaptiveDroplist, {
            layoutType: layoutType,
            placement: "bottom-end",
            size: "m",
            closeDroplistOnItemClick: true,
            items: [{
              id: 'remove',
              content: {
                option: 'Удалить'
              },
              onClick: function onClick(e) {
                e.stopPropagation();
                onProductDelete(id, idx);
              }
            }],
            children: /*#__PURE__*/_jsx(ButtonFunction, {
              icon: /*#__PURE__*/_jsx(KebabSVG, {}),
              size: "m",
              onClick: function onClick(e) {
                e.stopPropagation();
              }
            })
          })]
        })
      })
    }, id + '_' + idx)
  });
}